export const underHeaderProps = {
  id: 'java-development-company',
};
